import InventoryCarousel from './InventoryCarousel';
export default InventoryCarousel;